import React from "react";

const collectData = (data) => {
  return new Promise((resolve, reject) => {
    if (process.env.NODE_ENV !== "production") {
      console.log(data);
      resolve("Data collected");
      return;
    }
    fetch(process.env.NEXT_PUBLIC_SS_METRICS_URL + "/event", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then(async (r) => {
        if (!r.ok) {
          reject("Error collecting data");
        }
        resolve("Data collected");
      })
      .catch(() => {
        reject("Error collecting data");
      });
  });
};

export default function useCollectEvents() {
  const collectEvent = React.useCallback(({ event, value }) => {
    const payload = {
      event,
      value,
    };
    collectData(payload);
  }, []);

  return { collectEvent };
}
